// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileCategoryComm_root__10dyZ","header":"MobileCategoryComm_header__1a4Yu","body":"MobileCategoryComm_body__3MWMI","commLabel":"MobileCategoryComm_commLabel__3nfL2"};